var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.403,
    height: 18.632,
    viewBox: "0 0 22.403 18.632",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "customer",
    d: "M24.3,21.051A70.571,70.571,0,0,0,17.7,18.228a2.606,2.606,0,0,1-1.317-1.41s-.424.234-.424-.424.424.424.847-2.118c0,0,1.176-.33.943-3.058h-.283s.706-2.917,0-3.9A4.047,4.047,0,0,0,14.926,5.2c-1.554-.471-.989-.377-2.118-.329s-2.071.659-2.071.988a1.924,1.924,0,0,0-.988.33A5.142,5.142,0,0,0,9,8.112a14.673,14.673,0,0,0,.471,3.012l-.28.092c-.235,2.729.94,3.06.94,3.06.424,2.541.847,1.458.847,2.118s-.424.424-.424.424a2.615,2.615,0,0,1-1.317,1.41A69.534,69.534,0,0,0,2.645,21.05c-.424.432-.377,2.407-.377,2.407h10L13,20.581l-.649-.649,1.116-1.118,1.116,1.117-.649.649.73,2.876h10s.052-1.976-.377-2.407Z",
    transform: "translate(-2.267 -4.825)",
    fill: "#6e7c8b"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.759d14bd4235d827bc759bf44066e048.svg";
export { ForwardRef as ReactComponent };